import { axiosInstance } from "../utils/axiosInstance";

export const RequestLoginOtp = async (data) => {
    return await axiosInstance.post("/login_otp", data);
}

export const LoginService = async (data) => {
    return await axiosInstance.post("/login", data);
}